module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2019_01.4cbdcaa8.jpg";